// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import { Menu, Carousel, CarouselItem, MenuItem, MenuItemGroup, } from 'element-ui';
import App from './App'
import router from './router'

import VueRouter from 'vue-router'
import './styles/common.css'
import 'babel-polyfill'

Vue.config.productionTip = false

Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Carousel)
Vue.use(CarouselItem)

Vue.use(VueRouter)
/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js